export default "__VITE_ASSET__94L_lHJG__"